<template>
  <div>
    <SearchSelect v-bind="$attrs" :api="apiGroupName" prop="supplierGroups" :get-value="getValue" :get-label="getLabel" v-on="$listeners" />
  </div>
</template>

<script>
import SearchSelect from '@/components/select/search-select/search-select.vue'
import http from '@/plugin/axios'

export default {
  components: {
    SearchSelect
  },
  methods: {
    apiGroupName() {
      return http({
        url: '/sysEnum/getEnumByType',
        baseURL: process.env.VUE_APP_BASE_API,
        data: { enumMid: 'supplierGroup' },
        loading: false
      })
    },
    getValue: (row) => row.enumValue,
    getLabel: (row) => `${row.enumName}`
  }
}
</script>

<style lang="scss" scoped>

</style>
